import React from "react";
import { Layout } from "../../layouts/Layout";
import {
  CHECK_ICON,
  SD_WORKING_IMG03,
  SD_WORKING_IMG04,
  SERVICES_DETAILS04,
} from "../../lib/assets";
import { ServicesDetailsWrapper } from "../../components/ServicesDetails/ServicesDetailsWrapper";
import { BrandSeven } from "../../components/Brand/BrandSeven";
import { ServicesDetailsFaq4 } from "../../components/ServicesDetails/ServicesDetailsFaq4";

const ServicesDetailsPageFour = () => {
  return (
    <Layout footer = {2} breadcrumb={"Services"} title={"Vendor Development Audits"}>
      {/* services-details-area */}
      <ServicesDetailsWrapper>
        <div className="services-details-wrap">
          <div className="services-details-content">
            <div className="sd-inner-wrap-four">
              <div className="row align-items-center">
                <div className="col-55">
                  <div className="thumb">
                    <img src={SERVICES_DETAILS04} alt="" style={{width:"457px", height:"380px"}} />
                  </div>
                </div>
                <div className="col-45">
                  <div className="content">
                    <h2 className="title">
                      Vendor Development Audits: Ensuring Excellence in Your Supply Chain
                    </h2>
                    <p>
                    In today’s competitive business landscape, ensuring that your vendors meet the highest 
                    standards of quality, efficiency, and reliability is essential for seamless operations 
                    and business success. 
                    </p>
                   {/* <ul className="list-wrap">
                      <li>
                        <img src={CHECK_ICON} alt="" />
                        100% Better results
                      </li>
                      <li>
                        <img src={CHECK_ICON} alt="" />
                        Valuable Ideas
                      </li>
                      <li>
                        <img src={CHECK_ICON} alt="" />
                        Budget Friendly Theme
                      </li>
                      <li>
                        <img src={CHECK_ICON} alt="" />
                        Happy Customers
                      </li>
                    </ul> */}
                  </div>
                </div>
              </div>
            </div>
            <div className="services-details-list-three">
              <ul className="list-wrap">
                <li>
                  <div className="icon">
                    <i className="flaticon-family"></i>
                  </div>
                  <div className="content">
                    <h4 className="title">Enhanced Quality Control</h4>
                    <p>
                    Ensure your vendors meet product and service quality benchmarks
                    </p>
                  </div>
                </li>
                <li>
                  <div className="icon">
                    <i className="flaticon-winner"></i>
                  </div>
                  <div className="content">
                    <h4 className="title">Improved Risk Management</h4>
                    <p>
                    Identify potential risks and implement strategies to mitigate disruptions
                    </p>
                  </div>
                </li>
              </ul>
            </div>
            <p>
            At Trio Management Consultancy, our Vendor Development Audits service 
            is designed to evaluate, optimize, and enhance the performance of your vendors, 
            ensuring they align with your organizational goals and industry standards.
            </p>
            <div className="industrial-working-wrap mt-50">
              <h2 className="title-two">
              Our Approach to Vendor Development Audits
              </h2>
              <p className="info-one">
              At Trio Management Consultancy, we adopt a structured approach to help businesses 
              gain clarity and control over their vendor performance:
              </p>
              {/*<div className="row">
                <div className="col-md-6">
                  <img src={SD_WORKING_IMG03} alt="" />
                </div>
                <div className="col-md-6">
                  <img src={SD_WORKING_IMG04} alt="" />
                </div>
              </div>
              <p>
                when an unknown printer took a galley of type and scrambled it
                to make a type specimen bookhas a not only five centuries, but
                also the leap into electronic typesetting, remaining essentially
                unchan galley of type and scrambled it to make a type specimen
                book.
              </p>*/}
            </div>

            {/* faq */}
            <ServicesDetailsFaq4 />
          </div>
        </div>
      </ServicesDetailsWrapper>

      {/* brand-area */}
      <BrandSeven />
    </Layout>
  );
};

export default ServicesDetailsPageFour;
